import * as types from './mutation-types'

export default {
    /**
     * 初始化clientid
     */
    [types.INIT_CLIENT_ID] (state, obj) {
        obj.id = parseInt(obj.id)
        if (isNaN(obj.id)) {
            obj.id = 1
        }
        state.clientId = obj.id
        // 设置logo地址
        state.logo = obj.logo
        state.miniLogo = obj.miniLogo
        state.background = obj.background
        // 这里强者，不是正式环境，就是测试环境
        state.env = obj.env == 'release' ? 'release' : 'test'
    },
    [types.UPDATE_TOKON] (state, tokon) {
        state.tokon = tokon
    },
    [types.UPDATE_HLFTOKON] (state, hlftokon) {
        state.hlftokon = hlftokon
    },
    /**
     * 登录标识设置
     */
    [types.UPDATE_AUTHORIZD] (state, bool) {
        state.authorizd = bool
    },
    /**
     * 初始化用户信息
     */
    [types.INIT_USER_INFO] (state, info) {
        state.userInfo = info
    },

    /**
     * 初始化配置
     */
    [types.INIT_CONFIG] (state, config) {
        state.config = config
    },
    /**
     * 设置当前menu的配置
     * @param label 页面的唯一标志label
     */
    [types.SET_CURR_MENU] (state, label) {
        let menu = null
        let config = state.config.config
        for (let i = 0, len = config.length; i < len; i++) {
            let children = config[i]['children']
            for (let j = 0, jlen = children.length; j < jlen; j++) {
                if (children[j]['label'] == label) {
                    menu = children[j]
                    break;
                }
            }
            if (menu) {
                break;
            }
        }
        state.currMenu = menu
    },
    /**
     * 设置当前的页面
     * @param label 页面的label 唯一标识
     */
    [types.SET_CURR_PAGE] (state, label) {
        let p = null
        if (state.currMenu) {
            let pages = state.currMenu.page
            for (let i = 0, len = pages.length; i < len; i++) {
                if (pages[i]['label'] == label) {
                    p = pages[i]
                    break;
                }
            }
        } 
        if (!state.currMenu || !p) { // 全局查找
            let config = state.config.config
            for (let i = 0, len = config.length; i < len; i++) {
                let child = config[i]['children']
                for (let j = 0, jlen = child.length; j < jlen; j++) {
                    let pages = child[j].page
                    for (let k = 0, len = pages.length; k < len; k++) {
                        if (pages[k]['label'] == label) {
                            state.currMenu = child[j] // 设置currMenu
                            p = pages[k] // 设置 currPage
                            break;
                        }
                    }
                    if (p) {
                        break;
                    }
                }
                if (p) {
                    break;
                }
            }
        }
        state.currPage = p
    },

    /**
     * 2019-10-30 区分显示需要带入的ID
     * @param {*} id 
     */
    [types.SET_HUBBLE_ID] (state, id) {
        state.hubbleId = id
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js